"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_SUPER_BONUS_DETAILS = exports.TicketTypes = void 0;
var TicketTypes;
(function (TicketTypes) {
    TicketTypes["TICKET_VALUE"] = "PRICE_DOLLAR";
    TicketTypes["TICKET_QUANTITY"] = "ENTRY";
})(TicketTypes || (exports.TicketTypes = TicketTypes = {}));
exports.GET_SUPER_BONUS_DETAILS = 'superBonus/GET_SUPER_BONUS_DETAILS';
//# sourceMappingURL=types.js.map